import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment';

import { PickUp, PickUpForOverview } from '../models/pick-up.model';
@Injectable({
  providedIn: 'root',
})
export class GrainPickupService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = `${this.env.APIM_BASE_URL}/arable-service/grainregistration/grainpickuprequest`;

  getPickUpListByCropYear(cropYear: number) {
    return this.http.get<{ grainPickUpRequests: PickUpForOverview[] }>(
      `${this.baseUrl}/year/${cropYear}`,
      {},
    );
  }

  getPickUpListByTransporter(cropYear: number, profileId: number) {
    return this.http.get<{ grainPickUpRequests: PickUpForOverview[] }>(
      `${this.baseUrl}/cropYear/${cropYear}/profile/${profileId}`,
      {},
    );
  }

  getPickUpListByCustomer(cropYear: number) {
    return this.http.get<{ grainPickUpRequests: PickUpForOverview[] }>(
      `${this.baseUrl}/cropYear/${cropYear}/customer`,
      {},
    );
  }

  removeGrainPickup(pickupId: number) {
    return this.http.delete(`${this.baseUrl}/${pickupId}`);
  }

  saveGrainPickup(pickup: PickUp) {
    return this.http.post<PickUp>(`${this.baseUrl}`, pickup, {});
  }

  getPickupRegistrationDocument(id: string) {
    return this.http.get(`${this.baseUrl}/document/${id}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
